export const Constants = {
    monitor: {
        defaultInterval: 200,
        defaultRows: 3,
    },
};
